module.exports = __webpack_public_path__ + "static/media/close.5f60623b.svg";